import { createContext, useContext } from 'react';

export interface ProjectApi {
  /** 0 = all projects (legacy ALL_PROJECTS) */
  projectId: number;
  setProjectId: (id: number) => void;
}

export const ProjectContext = createContext<ProjectApi>({
  projectId: 0,
  setProjectId: () => undefined,
});
export const useCurrentProject = () => useContext(ProjectContext);
